import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { EN, PT_BR } from 'resources/strings'
import { getLocaleFromHostname } from 'resources/siteLocales'

const initialLanguage = getLocaleFromHostname(window.location.hostname)

i18n.use(initReactI18next).init({
	resources: {
		en: {
			translation: EN,
		},
		'pt-BR': {
			translation: PT_BR,
		},
	},
	lng: initialLanguage,
	fallbackLng: 'pt-BR',

	interpolation: {
		escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
	},
})

const updateDocumentLanguage = (language) => {
	const resolvedLanguage = language.toLowerCase().startsWith('en')
		? 'en'
		: 'pt-BR'
	document.documentElement.lang = resolvedLanguage
}

updateDocumentLanguage(initialLanguage)
i18n.on('languageChanged', updateDocumentLanguage)

export default i18n
